import React, { Component } from 'react';
import { View } from '../UIElements/All.js';
import { Colors, ButtonColors } from '../Managers/ThemeManager';
import { isRetail } from '../Managers/Utils';
import Loc from './Localization'

export default class Tip extends Component 
{
  constructor(props) 
  {
    super(props);
    var state = {};
    state.showTip = true;
    this.state = state;
  }

  setIsUpdating(isUpdating)
  {
    this.setState({isUpdating});
  }

  getModal()
  {
    return this._modal;
  }

  render() 
  {
    if( !isRetail() || !this.state.showTip ) return null;
    if( typeof this.props.title === 'undefined' || typeof this.props.body === 'undefined' ) return null;

  	var self = this;
    var style = typeof this.props.style === 'undefined' ? {} : this.props.style;
    style.flex = -1;
    style.flexDirection = "column";
    style.alignItems = 'flex-start';
    style.borderWidth = 1;
    style.borderStyle = "solid";
    style.borderRadius = 8;
    style.marginTop = 12;
    style.width = 660;
    style.padding = 12;
    style.cursor = 'pointer';
    if( typeof this.props.type === 'undefined' || this.props.type == 0 )
    {
      style.backgroundColor = Colors.background3;
      style.borderColor = Colors.border3;
    }
    else if( this.props.type == 1 )
    {
      style.backgroundColor = Colors.background5;
      style.borderColor = Colors.border5;
      style.borderTopWidth = 4;
      style.borderTopStyle = 'solid';
      style.borderTopColor = Colors.border6;
    }

    return (
      <View style={{flex:-1, alignSelf:'stretch', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
        <View style={style}
          onClick={() => this.setState({showTip:false})}>
          <View style={{fontSize:16, fontWeight:'bold', padding:4, color:Colors.text3, flexDirection:'row', alignSelf:'stretch'}}>
            {
              this.props.type == 1 ?
                <View style={{borderRadius:8, width:16, height:16, backgroundColor:ButtonColors.primaryBackground, color:ButtonColors.primaryText, flex:-1, textAlign:'center', alignItems:'center', justifyContent:'center', fontSize:10, margin:2, marginRight:8}}>
                {"✓"}
                </View>
              : null
            }
            <View style={{flex:1, textAlign:'left'}}>
              <Loc locKey={this.props.title}></Loc>
            </View>
            {
              this.props.type != 1 ?
                <View style={{width:20, height:20, alignItems:'center', justifyContent:'center', fontSize:16, paddingBottom:4, borderRadius:10, flex:-1, backgroundColor:"rgba(0,0,0,.1)", color:"rgba(0,0,0,.6)"}}>
                {"x"}
                </View>
              : null
            }
          </View>
          <View style={{fontSize:14, padding:4, textAlign:'left', color:Colors.text4, marginLeft:this.props.type == 1 ? 26 : 0}}>
            <Loc locKey={this.props.body}></Loc>
          </View>
        </View>
      </View>
    );
  }
}

